// x-autosize: grows a <textarea> to fit its content, up to a max height,
// then scrolls. Kept generic and reusable across forms.
export default function registerAutosize(Alpine) {
  Alpine.directive("autosize", (el) => {
    const MAX = 240; // px
    const resize = () => {
      el.style.height = "auto";
      const natural = el.scrollHeight; // content height, measured before clamping
      el.style.height = `${Math.min(natural, MAX)}px`;
      el.style.overflowY = natural > MAX ? "auto" : "hidden";
    };
    el.addEventListener("input", resize);
    // Size once after layout so the initial value (if any) fits.
    window.requestAnimationFrame(resize);
  });
}
